import { render, staticRenderFns } from "./JournalImport.vue?vue&type=template&id=2dcdc4b8"
import script from "./JournalImport.vue?vue&type=script&lang=js"
export * from "./JournalImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports